import { TDeal } from "@/models/deals.model";
import { z } from "zod";

export type Props = {
  open: boolean;
  leadId?: number;
  onClose: () => void;
  onDealCreated: (deal: TDeal) => void;
};

export const createDealSchema = z.object({
   pipeline: z.number({ error: "Pipeline is required" }),
  name: z.string({ error: "Deal name is required" }).min(1, "Deal name is required"),
   status: z.number({ error: "Status is required" }),
  amount: z.number().nonnegative("Amount can't be negative").optional(),
  currency: z.string().min(1, "Currency is required"),
  tags: z.array(z.string()).optional(),
  leadId: z.number({ error: "Lead is required" }),
});
